import type { Bucket } from './bucket';
import z from 'zod';

export type BucketUpdateId = z.infer<typeof BucketUpdateId>;

export const BucketUpdateId = z.object({
    id: z.string(),
    _v: z.number(),
});

export function createBucketUpdateId(bucket: Bucket): BucketUpdateId {
    return {
        id: bucket.id,
        _v: bucket._v ?? 0,
    };
}
